<template>
  <v-container fluid>
    <v-tooltip bottom v-for="(item, index) of value" :key="index" :color="statusColor(item)">
      <template v-slot:activator="{ on, attrs }">
        <v-chip
            small
            outlined
            :color="statusColor(item)"
            v-bind="attrs"
            v-on="on"
        >
          {{ item.order }}
        </v-chip>
      </template>
      <span>{{ item.name }}</span>
    </v-tooltip>
  </v-container>
</template>

<script>

export default {
  name: 'CoreBatchRunReservationStatus',
  props: {
    value: {
      type: [Array], default: function () {
        return []
      }
    },
  },

  components: {},

  computed: {},

  methods: {
    statusColor(item) {
      if (item.reservation_status === true)
        return 'success'
      if (item.reservation_status === false)
        return 'error'
      return 'warning'
    },
  },

  mounted() {
  },

  data() {
    return {}
  },
}

</script>


<style scoped lang="scss">
</style>